var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      attrs: {
        "show-footer": false,
        title: _vm.$t("message.sendTemplateMessage"),
        className: "template-message-modal",
      },
      on: {
        cancel: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "template-message-modal" }, [
        _c("div", { staticClass: "template-message-modal-content" }, [
          _c(
            "div",
            { staticClass: "template-message-modal-preview" },
            [
              _c("WABATemplateMessage", {
                attrs: { data: _vm.getPreviewTemplatePayload(), float: "left" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "template-message-modal-content-editor" }, [
            ["IMAGE", "VIDEO", "DOCUMENT"].includes(_vm.template.templateType)
              ? _c("div", { staticClass: "image-picker" }, [
                  _c("div", { staticClass: "editor-row" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{\n                                followCursor: true,\n                                placement: 'bottom-end',\n                            }",
                          },
                        ],
                        staticClass: "editor-row-title",
                        attrs: {
                          content: _vm.$t(
                            "message.templateMediaCustomizeTooltip"
                          ),
                        },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("message.mediaLabelShort")) +
                            "\n                            "
                        ),
                        _c("span", { staticClass: "optional" }, [
                          _vm._v(
                            _vm._s(_vm.$t("whatsapp_business_api.optional"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("a-icon", { attrs: { type: "question-circle" } }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.media
                      ? _c("div", { staticClass: "media-preview" }, [
                          _c("div", { staticClass: "media-preview-content" }, [
                            _c("div", { staticClass: "media-image" }, [
                              _c("img", {
                                attrs: { src: _vm.media.data, alt: "" },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "media-preview-name" }, [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(_vm.media.name) +
                                  "\n                                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "media-preview-delete",
                              on: { click: _vm.deleteMedia },
                            },
                            [
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("delete"),
                              ]),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "media-drag" }, [
                          _c("div", { staticClass: "input" }, [
                            _c("input", {
                              attrs: {
                                type: "file",
                                id: "media-source",
                                accept: _vm.getAcceptType(),
                              },
                              on: { change: _vm.handleFileUpload },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "material-icons" }, [
                            _vm._v("image"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content" }, [
                            _vm._v(
                              _vm._s(_vm.$t("auto.clickHereToUploadPicture"))
                            ),
                          ]),
                        ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "description" }, [
                      _c("div", { staticClass: "input-warn" }, [
                        _c("div", [
                          _c("b", [_vm._v(_vm._s(_vm.$t("auto.note")) + ":")]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("auto.acceptedFileFormatsAndSizes")
                              ) +
                              "\n                                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("ul", { staticClass: "list-item" }, [
                          _c("li", [
                            _vm._v(_vm._s(_vm.$t("auto.imageJpegPngMax2Mb"))),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(_vm._s(_vm.$t("auto.videoMp4Max20Mb"))),
                          ]),
                          _vm._v(" "),
                          _c("li", [
                            _vm._v(_vm._s(_vm.$t("auto.documentMax2Mb"))),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "template-message-modal-params" }, [
              _vm.headerParams.length > 0
                ? _c(
                    "div",
                    { staticClass: "param-category" },
                    [
                      _c("div", { staticClass: "param-category-title" }, [
                        _vm._v(_vm._s(_vm.$t("auto.headerParameters"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.headerParams, function (param, index) {
                        return _c(
                          "div",
                          { key: "header-" + index, staticClass: "editor-row" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("auto.headerParameter")) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-textarea", {
                              staticClass: "full-width-textarea",
                              attrs: {
                                placeholder: _vm.$t(
                                  "auto.headerParameterValue"
                                ),
                              },
                              model: {
                                value: _vm.headerParams[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.headerParams, index, $$v)
                                },
                                expression: "headerParams[index]",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.bodyParams.length > 0
                ? _c(
                    "div",
                    { staticClass: "param-category" },
                    [
                      _c("div", { staticClass: "param-category-title" }, [
                        _vm._v(_vm._s(_vm.$t("auto.bodyParameters"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.bodyParams, function (param, index) {
                        return _c(
                          "div",
                          { key: "body-" + index, staticClass: "editor-row" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("auto.bodyParameter")) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-textarea", {
                              staticClass: "full-width-textarea",
                              attrs: {
                                placeholder: _vm.$t("auto.bodyParameterValue"),
                              },
                              model: {
                                value: _vm.bodyParams[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.bodyParams, index, $$v)
                                },
                                expression: "bodyParams[index]",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.carouselParams.length > 0
                ? _c(
                    "div",
                    { staticClass: "param-category" },
                    [
                      _c("div", { staticClass: "param-category-title" }, [
                        _vm._v(_vm._s(_vm.$t("auto.carouselParameters"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.carouselParams, function (param, index) {
                        return _c(
                          "div",
                          {
                            key: "carousel-" + index,
                            staticClass: "editor-row",
                          },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("auto.carouselParameter")) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-textarea", {
                              staticClass: "full-width-textarea",
                              attrs: {
                                placeholder: _vm.$t(
                                  "auto.carouselParameterValue"
                                ),
                              },
                              model: {
                                value: _vm.carouselParams[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.carouselParams, index, $$v)
                                },
                                expression: "carouselParams[index]",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.buttonParams.length > 0
                ? _c(
                    "div",
                    { staticClass: "param-category" },
                    [
                      _c("div", { staticClass: "param-category-title" }, [
                        _vm._v(_vm._s(_vm.$t("auto.buttonParameters"))),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.buttonParams, function (param, index) {
                        return _c(
                          "div",
                          { key: "button-" + index, staticClass: "editor-row" },
                          [
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("auto.buttonParameter")) +
                                  " " +
                                  _vm._s(index + 1)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("a-textarea", {
                              staticClass: "full-width-textarea",
                              attrs: {
                                placeholder: _vm.$t(
                                  "auto.buttonParameterValue"
                                ),
                              },
                              model: {
                                value: _vm.buttonParams[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.buttonParams, index, $$v)
                                },
                                expression: "buttonParams[index]",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "template-message-modal-actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { primary: "" },
                on: {
                  click: function ($event) {
                    _vm.$emit("send", _vm.getPayload())
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("auto.send")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { ghost: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("close")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("auto.cancel")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }